module.exports = __webpack_public_path__ + "static/media/component-2.f34bec3e.svg";